import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import "./styles/index/index.css";

import "./i18n/i18n";
import ModalCpntextProvider from "./context/ModalContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ModalCpntextProvider>
        <App />
      </ModalCpntextProvider>
    </BrowserRouter>
  </React.StrictMode>
);
